export var fnoMarginDetailsMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (items) {
            return {
                DPC_Month: items.DPC_Month,
                Value: items.Value,
                ID: items.ID,
                fnodetails: items.fnodetails.map(function (item) {
                    return {
                        Trxdate: item.Trxdate,
                        ExchngMarginReq: item.ExchngMarginReq,
                        halfExchngMarginReq: item.halfExchngMarginReq,
                        AvailableCashMargin: item.AvailableCashMargin,
                        AvailableCashEQ: item.AvailableCashEQ,
                        DPC_Chargeable_Amount: item.DPC_Chargeable_Amount,
                        DPC_Charges_Percentage: item.DPC_Charges_Percentage,
                        DPC_Perday: item.DPC_Perday,
                        ID: item.ID
                    };
                }),
            };
        });
    }
    return result;
};
